// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PermissionRequestItem__item-d1eebe {
  width: 100%;
  box-sizing: border-box;
}

.PermissionRequestItem__container-a36a16 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
}

.PermissionRequestItem__nameBlock-b984f7 {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.PermissionRequestItem__avatar-c466d3 {
  margin-inline-end: 12px;
}

.PermissionRequestItem__title-d80424 {
  color: var(--addition-50);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
}

.PermissionRequestItem__buttons-c97eff {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.PermissionRequestItem__menuButton-ee7786 {
  height: 32px;
  width: 32px;
  padding: 0;
}

.PermissionRequestItem__menuButton-ee7786:first-child {
  margin-inline-end: 16px;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/FullScreenCallView/Shared/AnimatedRightPanel/RequestedPermissionsPanel/components/PermissionRequestItem/PermissionRequestItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,yBAAA;EACA,wBAAA;EACA,0CAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,UAAA;AACF;;AAEA;EACE,uBAAA;AACF","sourcesContent":[".item {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 16px;\n}\n\n.nameBlock {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.avatar {\n  margin-inline-end: 12px;\n}\n\n.title {\n  color: var(--addition-50);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n}\n\n.buttons {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.menuButton {\n  height: 32px;\n  width: 32px;\n  padding: 0;\n}\n\n.menuButton:first-child {\n  margin-inline-end: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `PermissionRequestItem__item-d1eebe`,
	"container": `PermissionRequestItem__container-a36a16`,
	"nameBlock": `PermissionRequestItem__nameBlock-b984f7`,
	"avatar": `PermissionRequestItem__avatar-c466d3`,
	"title": `PermissionRequestItem__title-d80424`,
	"buttons": `PermissionRequestItem__buttons-c97eff`,
	"menuButton": `PermissionRequestItem__menuButton-ee7786`
};
module.exports = ___CSS_LOADER_EXPORT___;
